import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicComboboxEvent } from "@goodgamestudios/core";

import { int } from "@goodgamestudios/math-utilities";

import { BasicTutorialController } from "../../../basic/controller/BasicTutorialController";
import { antiCheating, AUTO_TABLE } from '../../antiCheating/AntiCheating';
import { SFConstants } from "../../constants/SFConstants";
import { Poker2AntiCheatEvent } from "../../event/Poker2AntiCheatEvent";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2LobbyDataEvent } from "../../event/Poker2LobbyDataEvent";
import { Poker2TutorialEvent } from "../../event/Poker2TutorialEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { CreateTablesVO } from "../../gamevo/CreateTablesVO";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2MouseWheelUpDown } from "../components/Poker2MouseWheelUpDown";
import { Poker2CreateTableDialogProperties } from "../dialogs/lobby/Poker2CreateTableDialogProperties";
import { Poker2Screen } from "./Poker2Screen";

import { NumberStringHelper } from "../../helper/NumberStringHelper";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class Poker2LobbyTablesScreen extends Poker2Screen {
    public static NAME: string = "Poker2LobbyTablesScreen";
    private lastSelectedTableName: string; // for restore after scroll
    private selectedTableLine: Library.PokerInterface.TableLine;
    private selectedSortPanel: MovieClip;
    private inputComboBox: Poker2DynamicCombobox;
    private tableTypeComboBox: Poker2DynamicCombobox;
    private MAX_LINES: number = 15;
    private SELECT_ALL_POS: number = 3;
    private SHOW_ALL_TABLETYPES: number = -1;
    private mouseWheelUpDown: Poker2MouseWheelUpDown;

    private waitTableDataLoad: boolean = false;	//	keine neuen daten anfordern, bevor die letzten noch nicht da sind
    private static LOBBY_TABLE_COLUMNS_AMOUNT: number = 6;
    private static TABLE_HEAD_TOOLTIPS: any[];

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();

        // Map tooltips to the table head buttons.
        // Caution, order of the table header buttons in the fla is: 0,5,1,2,3,4
        // 0 = tables
        // 1 = stacks
        // 2 = players
        // 3 = spectators
        // 4 = pot
        // 5 = xp
        Poker2LobbyTablesScreen.TABLE_HEAD_TOOLTIPS = [Poker2Model.languageData.getTextById("lobby_tab_tooltip_tables"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_stacks"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_players"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_spectators"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_pot"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_xp")];

        this.controller.addEventListener("changeUserLobbyConfig", this.bindFunction(this.onLobbyConfig));
        this.controller.addEventListener("changeLobbyTableData", this.bindFunction(this.onLobbyTableData));
        this.lobbyTablesScreen.addEventListener(MouseEvent.DOUBLE_CLICK, this.bindFunction(this.onDoubleClick));
        this.lobbyTablesScreen.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        this.lobbyTablesScreen.bg_title.doCache();
        this.setHelperProperties();
        this.mouseWheelUpDown = new Poker2MouseWheelUpDown();
        this.mouseWheelUpDown.init(this.lobbyTablesScreen.btn_up, this.lobbyTablesScreen.btn_down, this.lobbyTablesScreen);
        this.initToolTips();
    }

    private initToolTips(): void {
        // tooltip refresh button
        this.lobbyTablesScreen.btn_refresh.toolTipText = Poker2Model.languageData.getTextById("lobby_btn_tooltip_refresh");

        this.initToolTipsTableHead();
    }

    private initToolTipsTableHead(): void {
        var i: number = 0;
        var len: number = Poker2LobbyTablesScreen.LOBBY_TABLE_COLUMNS_AMOUNT;
        var tempTableHeadButton: MovieClip;
        for (i = 0; i < len; ++i) {
            tempTableHeadButton = this.lobbyTablesScreen["sort_" + i];
            tempTableHeadButton.toolTipText = Poker2LobbyTablesScreen.TABLE_HEAD_TOOLTIPS[i];
        }
    }

    private initComboBoxes(): void {
        if (this.inputComboBox == null) {
            this.inputComboBox = new Poker2DynamicCombobox(this.lobbyTablesScreen.combo_bet, "", 4);
            this.inputComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_input_0") });
            this.inputComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_input_1") });
            this.inputComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_input_2") });
            this.inputComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_input_3") });
        }

        if (this.tableTypeComboBox == null) {
            this.tableTypeComboBox = new Poker2DynamicCombobox(this.lobbyTablesScreen.combo_tabletype, "", 4);
            this.tableTypeComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_tableTyp_0") });
            this.tableTypeComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_tableTyp_1") });
            this.tableTypeComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_tableTyp_2") });
            this.tableTypeComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_input_3") });
        }

        if (Poker2Model.userData.tableListVConfigVO) {
            var selectedInput: string = Poker2Model.languageData.getTextById("lobby_combo_input_" + Poker2Model.userData.tableListVConfigVO.input);
            this.inputComboBox.defaultString = selectedInput;
            this.inputComboBox.hideItems();
            var selectedTableTyp: string;
            if (Poker2Model.userData.tableListVConfigVO.tabletype != this.SHOW_ALL_TABLETYPES) {
                selectedTableTyp = Poker2Model.languageData.getTextById("lobby_combo_tableTyp_" + Poker2Model.userData.tableListVConfigVO.tabletype);
            }
            else {
                selectedTableTyp = Poker2Model.languageData.getTextById("lobby_combo_input_3");
            }
            this.tableTypeComboBox.defaultString = selectedTableTyp;
            this.tableTypeComboBox.hideItems();
        }
        else {
            this.inputComboBox.selectItemIndex(0);
            this.tableTypeComboBox.selectItemIndex(0);
        }
    }

    private setHelperProperties(): void {
        for (var i: number = 0; i < 6; i++)
            this.lobbyTablesScreen["sort_" + i].properties = i;
    }

    private onLobbyConfig(event: Poker2UserEvent): void {
        Poker2Model.userData.tableListVConfigVO.ignFull ? this.lobbyTablesScreen.checkBox1.selected() : this.lobbyTablesScreen.checkBox1.deselected();
        Poker2Model.userData.tableListVConfigVO.fOnly ? this.lobbyTablesScreen.checkBox2.selected() : this.lobbyTablesScreen.checkBox2.deselected();
        this.setSort(Poker2Model.userData.tableListVConfigVO.sort);
        this.initComboBoxes();
    }

    private setSort(sort: number): void {
        var sortPanel: MovieClip = castAs<MovieClip>(this.lobbyTablesScreen["sort_" + sort], "MovieClip");

        if (sortPanel != this.selectedSortPanel) {
            if (this.selectedSortPanel)
                this.selectedSortPanel.bg.gotoAndStop(1);
            this.selectedSortPanel = sortPanel;
            sortPanel.bg.gotoAndStop(2);
        }
    }

    private onLobbyTableData(event: Poker2LobbyDataEvent): void {
        this.fillTables(Poker2Model.lobbyData.lobbyTables);
    }

    private fillTables(lobbyTables: LobbyTablesVO[]): void {
        this.waitTableDataLoad = false;
        this.selectedTableLine = null;

        if (lobbyTables == null)
            return;

        if (lobbyTables.length < this.MAX_LINES)
            this.lobbyTablesScreen.btn_down.enableButton = false;
        else
            this.lobbyTablesScreen.btn_down.enableButton = true;

        for (var i: number = 0; i < this.MAX_LINES; i++) {
            var tItem: Library.PokerInterface.TableLine = this.lobbyTablesScreen["table" + i] as Library.PokerInterface.TableLine;

            if (lobbyTables.length - 1 < i) {
                tItem.visible = false;
                continue;
            }
            tItem.mc_background.gotoAndStop(1);
            tItem.visible = true;

            tItem.properties = lobbyTables[i].id;
            tItem.sblind = lobbyTables[i].sBlind;
            tItem.mc_xpsignal.gotoAndStop(lobbyTables[i].xpEarnStatus + 1);
            tItem.txt_tables_0.text = lobbyTables[i].name;
            tItem.tablename = lobbyTables[i].name;
            tItem.txt_tables_1.text = NumberStringHelper.groupString(lobbyTables[i].sBlind, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.txt_tables_2.text = lobbyTables[i].players.toString();
            tItem.txt_tables_3.text = lobbyTables[i].specs.toString();
            tItem.txt_tables_4.text = NumberStringHelper.groupString(lobbyTables[i].pot, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.txt_tables_0.mouseEnabled = false;
            tItem.txt_tables_1.mouseEnabled = false;
            tItem.txt_tables_2.mouseEnabled = false;
            tItem.txt_tables_3.mouseEnabled = false;
            tItem.txt_tables_4.mouseEnabled = false;
            tItem.doubleClickEnabled = true;
            tItem.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOverTableLine));
            tItem.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOutTableLine));
            if (lobbyTables[i].name == this.lastSelectedTableName) {
                this.selectedTableLine = null;
                this.activateTableLine(tItem);
            }
        }
    }

    private initTextFields(): void {
        this.lobbyTablesScreen.btn_play_table.minWidth = 20;
        this.lobbyTablesScreen.btn_play_table.label = Poker2Model.languageData.getTextById("lobby_btn_play_table");
        this.lobbyTablesScreen.txt_input_0.text = Poker2Model.languageData.getTextById("lobby_input");
        this.lobbyTablesScreen.txt_input_1.text = Poker2Model.languageData.getTextById("lobby_input");
        this.lobbyTablesScreen.txt_input.text = Poker2Model.languageData.getTextById("lobby_tableTyp");
        this.lobbyTablesScreen.txt_checkBox1.text = Poker2Model.languageData.getTextById("lobby_checkBox1");
        this.lobbyTablesScreen.txt_checkBox2.text = Poker2Model.languageData.getTextById("lobby_checkBox3");
        this.lobbyTablesScreen.txt_tables.text = Poker2Model.languageData.getTextById("lobby_tables");
        this.lobbyTablesScreen.txt_players.text = Poker2Model.languageData.getTextById("lobby_players");
        this.lobbyTablesScreen.txt_specs.text = Poker2Model.languageData.getTextById("lobby_specs");
        this.lobbyTablesScreen.txt_pot.text = Poker2Model.languageData.getTextById("lobby_pot");
        this.lobbyTablesScreen.txt_title.text = Poker2Model.languageData.getTextById("lobby_title");
        this.lobbyTablesScreen.btn_tournament.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tunier");
        this.lobbyTablesScreen.btn_sitngo.toolTipText = Poker2Model.languageData.getTextById("lobby_sitngo_title");
        this.lobbyTablesScreen.txt_xp.text = Poker2Model.languageData.getTextById("dialog_ranking_xp");
        this.lobbyTablesScreen.txt_tables.mouseEnabled = false;
        this.lobbyTablesScreen.txt_input_1.mouseEnabled = false;
        this.lobbyTablesScreen.txt_input_0.mouseEnabled = false;
        this.lobbyTablesScreen.txt_input.mouseEnabled = false;
        this.lobbyTablesScreen.txt_players.mouseEnabled = false;
        this.lobbyTablesScreen.txt_specs.mouseEnabled = false;
        this.lobbyTablesScreen.txt_pot.mouseEnabled = false;
        this.lobbyTablesScreen.txt_xp.mouseEnabled = false;
    }

    public show(): void {
        super.show();
        this.selectedTableLine = null;
        this.initTextFields();
        this.initComboBoxes();

        if (this.inputComboBox) {
            this.inputComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onInputComboboxChange));
        }
        if (this.tableTypeComboBox) {
            this.tableTypeComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onTableTypeComboboxChange));
        }
        this.lobbyTablesScreen.btn_tables.selected();
        this.lobbyTablesScreen.btn_tournament.deselected();
        this.fillTables(Poker2Model.lobbyData.lobbyTables);
        Poker2Model.userData.tableListVConfigVO.ignFull ? this.lobbyTablesScreen.checkBox1.selected() : this.lobbyTablesScreen.checkBox1.deselected();
        Poker2Model.userData.tableListVConfigVO.fOnly ? this.lobbyTablesScreen.checkBox2.selected() : this.lobbyTablesScreen.checkBox2.deselected();
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2LobbyTablesScreen", 1]));
        this.controller.addEventListener("playNow", this.bindFunction(this.playNow));
        this.mouseWheelUpDown.activateMouseWheel();

        // leave last visited table
        this.leaveLastTable();

        TableHeadButtonHelper.setHeadButtonsSizes([0.89, 0.82, 0.85, 1.15, 1.16, 0.46], this.lobbyTablesScreen);
    }
    private playNow(event: Poker2LobbyDataEvent): void {
        this.playSelectedTable();
    }

    public hide(): void {
        this.controller.removeEventListener("playNow", this.bindFunction(this.playNow));
        this.mouseWheelUpDown.deactivateMouseWheel();
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2LobbyTablesScreen", 0]));

        if (this.inputComboBox) {
            this.inputComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onInputComboboxChange));
        }
        if (this.tableTypeComboBox) {
            this.tableTypeComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onTableTypeComboboxChange));
        }
        super.hide();
    }

    private onInputComboboxChange(event: BasicComboboxEvent): void {
        if (this.isLocked || this.tutorialController.isActive) {
            return;
        }

        Poker2Model.userData.tableListVConfigVO.input = this.inputComboBox.selectedId;
        this.updateSettings(["input"]);
    }
    private onTableTypeComboboxChange(event: BasicComboboxEvent): void {

        if (this.isLocked || this.tutorialController.isActive) {
            return;
        }

        if (this.tableTypeComboBox.selectedId != this.SELECT_ALL_POS) {
            Poker2Model.userData.tableListVConfigVO.tabletype = this.tableTypeComboBox.selectedId;
        }
        else {
            Poker2Model.userData.tableListVConfigVO.tabletype = this.SHOW_ALL_TABLETYPES;
        }
        this.updateSettings(["tabletype"]);
    }

    public destroy(): void {
        super.destroy();

        for (var i: number = 0; i < this.MAX_LINES; i++) {
            var tItem: Library.PokerInterface.TableLine = this.lobbyTablesScreen["table" + i] as Library.PokerInterface.TableLine;
            if (tItem) {
                tItem.removeEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOverTableLine));
                tItem.removeEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOutTableLine));
            }
        }

        this.controller.removeEventListener("changeLobbyTableData", this.bindFunction(this.onLobbyTableData));
        this.controller.removeEventListener("changeUserLobbyConfig", this.bindFunction(this.onLobbyConfig));
        this.lobbyTablesScreen.removeEventListener(MouseEvent.DOUBLE_CLICK, this.bindFunction(this.onDoubleClick));
        this.mouseWheelUpDown.destroy();
    }

    private onDoubleClick(event: MouseEvent): void {
        if (this.tutorialController.isActive) {
            switch (this.tutorialController.tutorialState) {
                case "tut_step2_tableSelection":
                    if (event.target.parent.parent == this.lobbyTablesScreen.table0) {
                        this.tutorialController.nextStep();
                    }
                    break;
            }
            return;
        }
        if (instanceOfClass(event.target.parent.parent, "TableLine")) {
            this.selectedTableLine = event.target.parent.parent as Library.PokerInterface.TableLine;
            this.playSelectedTable();
        }
    }

    protected onTutorialEvent(event: Poker2TutorialEvent): void {
        if (this.tutorialController.isActive) {
            switch (this.tutorialController.tutorialState) {
                case BasicTutorialController.TUT_STATE_WELCOME:
                    this.layoutManager.state = 11;
                    break;
                case "tut_step2_tableSelection":
                    this.selectedTableLine = this.lobbyTablesScreen.table0;
                    this.activateTableLine(this.selectedTableLine);
                    this.layoutManager.tutPanel.showTutorialArrow(this.lobbyTablesScreen.table0.txt_tables_0);
                    this.layoutManager.tutPanel.hideSpotlight();
                    this.layoutManager.tutPanel.tableName = this.lobbyTablesScreen.table0.txt_tables_0.text;
                    break;
                case "tut_step3_playButton":
                    this.selectedTableLine = null;
                    this.activateTableLine(this.lobbyTablesScreen.table0);
                    this.layoutManager.tutPanel.showTutorialArrow(this.lobbyTablesScreen.btn_play_table);
                    this.layoutManager.tutPanel.hideSpotlight();
                    break;
            }
            return;
        }
    }

    protected onClick(event: MouseEvent): void {
        if (this.isLocked)
            return;

        if (this.tutorialController.isActive) {
            switch (this.tutorialController.tutorialState) {
                case "tut_step2_tableSelection":
                    if (event.target.parent.parent == this.lobbyTablesScreen.table0) {
                        this.tutorialController.nextStep();
                    }
                    break;
                case "tut_step3_playButton":
                    if (event.target == this.lobbyTablesScreen.btn_play_table) {
                        this.tutorialController.nextStep();
                    }
                    break;
            }
            return;
        }

        super.onClick(event);

        switch (event.target) {
            case this.lobbyTablesScreen.btn_tables:
                this.layoutManager.state = 11;
                break;
            case this.lobbyTablesScreen.btn_tournament:
                if (Poker2Model.userData.isGuest())
                    this.layoutManager.showDialog("Poker2RegisterGuestPopUpDialog", new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("alert_guestlogout_title"), Poker2Model.languageData.getTextById("alert_guesttournament_copy"), this.controller.onStartRegisterDialog, null, null, Poker2Model.languageData.getTextById("generic_login_register")));
                else {
                    Poker2Model.userData.tournamentConfigVO.tabletype = -1;
                    BasicModel.smartfoxClient.sendMessage("jli", [JSON.stringify({ tabletype: -1 })]);
                    this.layoutManager.state = 14;
                }
                break;
            case this.lobbyTablesScreen.btn_sitngo:

                BasicModel.smartfoxClient.sendMessage("sli", [JSON.stringify({})]);
                this.layoutManager.state = 17;
                break;
            case this.lobbyTablesScreen.btn_play_table:
                this.playSelectedTable();
                break;
            case this.lobbyTablesScreen.btn_refresh:
                this.updateSettings([]);
                break;
            case this.lobbyTablesScreen.btn_up:
                if (this.selectedTableLine) {
                    this.lastSelectedTableName = this.selectedTableLine.txt_tables_0.text;
                }
                this.updateSettings(["up"]);
                break;
            case this.lobbyTablesScreen.btn_down:
                if (this.lobbyTablesScreen.btn_down.enabled) {
                    if (this.selectedTableLine) {
                        this.lastSelectedTableName = this.selectedTableLine.txt_tables_0.text;
                    }
                    this.updateSettings(["down"]);
                }
                break;
            case this.lobbyTablesScreen.checkBox2:
                this.setCheckBoxStatus(this.lobbyTablesScreen.checkBox2, 0);
                break;
            case this.lobbyTablesScreen.checkBox1:
                this.setCheckBoxStatus(this.lobbyTablesScreen.checkBox1, 1);
                break;
            case this.lobbyTablesScreen.sort_0:
            case this.lobbyTablesScreen.sort_1:
            case this.lobbyTablesScreen.sort_2:
            case this.lobbyTablesScreen.sort_3:
            case this.lobbyTablesScreen.sort_4:
            case this.lobbyTablesScreen.sort_5:
                this.toggleTableButton(event.target as Library.PokerInterface.TabelButton);
                Poker2Model.userData.tableListVConfigVO.sort = event.target.properties;
                this.setSort(Poker2Model.userData.tableListVConfigVO.sort);
                this.updateSettings(["sort"]);

                // hgs HS859: erzwinge den anzeigewechsel, solange die maus über dem objekt bleibt
                event.target.dispatchEvent(new MouseEvent(MouseEvent.ROLL_OUT));
                event.target.dispatchEvent(new MouseEvent(MouseEvent.ROLL_OVER));
                break;
            default:
                let lineInstance = event.target.parent.parent;
                if (instanceOfClass(lineInstance, "TableLine"))
                    this.activateTableLine(lineInstance as Library.PokerInterface.TableLine);
                break;
        }
    }

    protected toggleTableButton(tabelButton: Library.PokerInterface.TabelButton): void {
        tabelButton.toggleDropDown();
    }

    private setCheckBoxStatus(checkBox: Library.PokerInterface.CheckBox, boxID: number): void {
        if (checkBox.isSelected)
            checkBox.deselected();
        else
            checkBox.selected();

        if (boxID == 0) {
            Poker2Model.userData.tableListVConfigVO.fOnly = checkBox.isSelected;
            this.updateSettings(["fOnly"]);
        }
        else if (boxID == 1) {
            Poker2Model.userData.tableListVConfigVO.ignFull = checkBox.isSelected;
            this.updateSettings(["ignFull"]);
        }
    }

    private onRollOverTableLine(event: MouseEvent): void {
        if (instanceOfClass(event.currentTarget, "TableLine")) {
            var item: Library.PokerInterface.TableLine = castAs<Library.PokerInterface.TableLine>(event.currentTarget, "TableLine");

            if (item != this.selectedTableLine)
                item.mc_background.gotoAndStop(2);
            this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
        }
    }

    private onRollOutTableLine(event: MouseEvent): void {
        if (instanceOfClass(event.currentTarget, "TableLine")) {
            var item: Library.PokerInterface.TableLine = castAs<Library.PokerInterface.TableLine>(event.currentTarget, "TableLine");

            if (item != this.selectedTableLine)
                item.mc_background.gotoAndStop(1);
            this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
        }
    }

    // TODO @HTML5 - Enable this logic after it is clear how to proceed with login to the same table, same machine with multuple accounts
    /*private playSelectedTable(): void {
        var now: Date = new Date();
        var timestamp: number = int(now.getTime());
        var evenNum: number = 0;
        var unevenNum: number = 0;

        if (this.isEven(timestamp)) {
            evenNum = timestamp;
            unevenNum = timestamp - 1;
        }
        else {
            evenNum = timestamp + 1;
            unevenNum = timestamp;
        }

        //Anti Cheat, gerader timestamp:OK, ungerader timestamp: Mehrer Clients geoeffnet
        this.rcv_lc = new LocalConnection();
        this.rcv_lc.client = this;
        this.controller.addEventListener("antiCheatRemoveConnection", this.bindFunction(this.removeConnection));
        try {
            if (this.selectedTableLine && !this.env.isLocal) {
                this.rcv_lc.connect("connectId" + this.selectedTableLine.properties + this.selectedTableLine.tablename);
            }
            var selectedTableId: number = int((this.selectedTableLine) ? this.selectedTableLine.properties : -1);
            var paramObject: any = { id: selectedTableId, ts: evenNum };
            BasicModel.smartfoxClient.sendMessage("tjn", [JSON.stringify(paramObject)]);
        } catch (error) {
            console.log("Can't connect...the connection name is already being used by another SWF");
            var selectedTableIdCheat: number = int((this.selectedTableLine) ? this.selectedTableLine.properties : -1);
            var paramObjectCheat: any = { id: selectedTableIdCheat, ts: unevenNum };
            BasicModel.smartfoxClient.sendMessage("tjn", [JSON.stringify(paramObjectCheat)]);
        }

    }*/

    private leaveLastTable(): void {
        antiCheating.unlockTable();
    }

    private playSelectedTable(): void {
        let timestamp: number = Date.now();
        let evenNum: number = 0;

        if (this.isEven(timestamp)) {
            evenNum = timestamp;
        } else {
            evenNum = timestamp + 1;
        }

        let selectedTableName: string = this.selectedTableLine ? this.selectedTableLine.properties + "_" + this.selectedTableLine.tablename : AUTO_TABLE;
        let selectedTableId: number = this.selectedTableLine ? this.selectedTableLine.properties : -1;
        let paramObject: any;

        // TODO @html5: check server code to know if timestamp is used only to authorize player (no cheating)
        // or is used for something else.
        // let paramObject: any = { id: selectedTableId, ts: evenNum };

        // store on memory the current table information
        antiCheating.table = selectedTableName;

        if (antiCheating.isTableFree()) {
            // table is free, allow connection to table
            paramObject = { id: selectedTableId, ts: 2 };
        } else {
            // table already taken, can't connect
            paramObject = { id: selectedTableId, ts: 2 - 1 };
        }

        BasicModel.smartfoxClient.sendMessage("tjn", [JSON.stringify(paramObject)]);
    }

    private isEven(timestamp: number): boolean {
        return timestamp % 2 === 0;
    }

    private removeConnection(evt: Poker2AntiCheatEvent): void {
        this.controller.removeEventListener("antiCheatRemoveConnection", this.bindFunction(this.removeConnection));
    }

    private updateSettings(properties: any[]): void {
        if (!this.waitTableDataLoad) {
            this.waitTableDataLoad = true;

            var paramObject: any = new Object();

            for (var i: number = 0; i < properties.length; i++)
                paramObject[properties[i]] = Poker2Model.userData.tableListVConfigVO[properties[i]];

            BasicModel.smartfoxClient.sendMessage("tli", [JSON.stringify(paramObject)]);
        }
    }

    private createTable(tablePrefs: CreateTablesVO): void {
        var paramObject: any = { help: tablePrefs.help, sBlind: tablePrefs.sBlind, bBlind: tablePrefs.bBlind, actionTime: tablePrefs.actionTime, fOnly: tablePrefs.fOnly };
        BasicModel.smartfoxClient.sendMessage("tcr", [JSON.stringify(paramObject)]);
    }

    private showCreateTableDialog(): void {
        this.layoutManager.showDialog("Poker2CreateTableDialog", new Poker2CreateTableDialogProperties(this.bindFunction(this.createTable)));
    }

    private activateTableLine(table: Library.PokerInterface.TableLine): void {
        if (this.selectedTableLine != table) {
            if (this.selectedTableLine)
                this.selectedTableLine.mc_background.gotoAndStop(1);

            table.mc_background.gotoAndStop(2);
            this.selectedTableLine = table;
        }
        else {
            table.mc_background.gotoAndStop(1);
            this.selectedTableLine = null;
        }
    }

    public get lobbyTablesScreen(): Library.PokerInterface.PokerLobbyTables {
        return this.disp as Library.PokerInterface.PokerLobbyTables;
    }
}
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2CreateTableDialog } from "../dialogs/lobby/Poker2CreateTableDialog";
import { Poker2RegisterGuestPopUpDialog } from "../dialogs/registration/Poker2RegisterGuestPopUpDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { castAs } from "@goodgamestudios/createjs-utilities";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {TableHeadButtonHelper} from "../helper/TableHeadButtonHelper";
import {Poker2DynamicCombobox} from "../components/Poker2DynamicCombobox";
